import api from '@/configurations/service';
import * as types from './mutation-types';

export const resetServiceState = async (context) => {
  context.commit(types.RESET_SERVICE);
};

export const saveService = async (_, payload) => {
  await api().post('consumers.register-service', payload);
};

export const updateService = async (_, payload) => {
  await api().post('consumers.update-service', payload);
};

export const deleteServices = async (context, payload) => {
  const { data } = await api().post('consumers.delete-services', { id: payload });

  context.commit(types.SET_SERVICES_WARNINGS, data.warnings);
  return data;
};

export const setDetailedService = async (context, id) => {
  const { data } = await api().post('consumers.find-detailed-service', { id });

  context.commit(types.SET_DETAILED_SERVICE, data);
};

export const setSummaryServices = async (context, { search, pagination }) => {
  const body = { search, pagination };
  const { data } = await api().post('consumers.find-summary-services', body);

  context.commit(types.SET_PAGINATION_SERVICE, data.pagination);
  context.commit(types.SET_SUMMARY_SERVICES, data.data);
};

export const setServiceCollection = async (context, payload) => {
  const body = { search: payload, isActive: true };
  const { data } = await api().post('consumers.find-summary-services', body);

  context.commit(types.SET_SERVICE_COLLECTION, data);
};
